import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";
import api from "../lib/api";

/**
 * LiveBadge — small pulsing "🔴 X LIVE" pill anchored top-left of the reels
 * feed, right below the SpinBanner. Shows count of currently live streamers
 * and taps into /live. Auto-refreshes every 45s. Auto-hides when 0.
 */
export default function LiveBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let stopped = false;
    const load = async () => {
      try {
        const { data } = await api.get("/live/active");
        if (!stopped) setCount(Array.isArray(data) ? data.length : 0);
      } catch { /* ignore */ }
    };
    load();
    const id = setInterval(load, 45_000);
    return () => { stopped = true; clearInterval(id); };
  }, []);

  if (count <= 0) return null;

  return (
    <Link to="/live" data-testid="live-badge"
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gradient-to-r from-[#FF2A5F] to-[#FF7A00] shadow-[0_4px_18px_rgba(255,42,95,0.5)] border border-white/20 active:scale-95 transition"
    >
      <span className="relative flex w-2 h-2">
        <span className="absolute inline-flex w-full h-full rounded-full bg-white opacity-70 animate-ping"/>
        <span className="relative inline-flex rounded-full w-2 h-2 bg-white"/>
      </span>
      <Radio className="w-3 h-3 text-white"/>
      <span className="text-[10px] font-outfit font-black tracking-wide text-white uppercase">{count} live</span>
    </Link>
  );
}
